import { formatPagination } from '../../utils/pagination';

class NotificationsDelegate {
    setLoading(loading) {
        this.setState({ loading });
    }

    setLoadError(loadError) {
        this.setState({ loadError });
    }

    setPerPage(value, callback) {
        this.setState({ listPageSize: value }, callback);
    }

    /** API `{ items, pageinfo }` → table rows + antd pagination config. */
    setPagination(items, pageinfo) {
        const pagination = formatPagination(pageinfo || {}) || null;
        this.setState({ items: items || [], pagination });
    }

    setTypeTab(value, callback) {
        this.setState({ typeTab: value }, callback);
    }

    setUnreadOnly(value, callback) {
        this.setState({ unreadOnly: !!value }, callback);
    }

    setPeriod(timeFrame, dateRange, callback) {
        this.setState({ timeFrame, dateRange }, callback);
    }

    /** Optimistically flag one row as read. */
    markItemRead(id) {
        const readAt = new Date().toISOString();
        this.setState((prev) => ({
            items: (prev.items || []).map((item) => (item.id === id && !item.readAt ? { ...item, readAt } : item)),
        }));
    }
}

export default NotificationsDelegate;
